var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterImg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76596 10.6667H7.21158V10.0025L7.53679 9.8904C8.28093 9.66008 8.91346 9.28708 9.43437 8.77142C9.95529 8.25575 10.313 7.72083 10.5074 7.16667H1.49258C1.68703 7.72083 2.04043 8.25575 2.55279 8.77142C3.06506 9.28708 3.69437 9.66008 4.44075 9.8904L4.76596 10.0025V10.6667ZM4.18262 11.25V10.4087C3.25454 10.12 2.48221 9.61895 1.86563 8.90544C1.24904 8.19202 0.877167 7.41799 0.75 6.58333H1.91667V1.77083L11.25 0.75V1.27719L5.08008 1.95706V3.18425H11.25V3.70035H5.08008V6.58333H11.25C11.1378 7.41799 10.7659 8.19202 10.1344 8.90544C9.50282 9.61895 8.723 10.12 7.79492 10.4087V11.25H4.18262ZM3.75635 3.18425H4.56413V2.01088L3.75635 2.09502V3.18425ZM2.43263 3.18425H3.2404V2.15219L2.43263 2.24421V3.18425ZM3.75635 6.58333H4.56413V3.70035H3.75635V6.58333ZM2.43263 6.58333H3.2404V3.70035H2.43263V6.58333Z",
    fill: "#2A2D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterImg5);
export default __webpack_public_path__ + "static/media/filterImg5.58cbfa87b99740736c52b5aa67f83f82.svg";
export { ForwardRef as ReactComponent };